/**
 * Lead capture popup: open on .lead-capture-form-trigger click.
 * Form ID and cooldown (minutes) from data-form-id and data-cooldown-minutes on #lead-capture-popup (ACF).
 */
(function () {
	const DEFAULT_FORM_ID = 0;
	const DEFAULT_COOLDOWN_MINUTES = 30;

	function getFormId() {
		const popupEl = document.getElementById("lead-capture-popup");
		if (!popupEl) return DEFAULT_FORM_ID;
		const id = parseInt(popupEl.getAttribute("data-form-id"), 10);
		return Number.isFinite(id) && id >= 1 ? id : DEFAULT_FORM_ID;
	}

	function getCooldownMs() {
		const popupEl = document.getElementById("lead-capture-popup");
		if (!popupEl) return DEFAULT_COOLDOWN_MINUTES * 60 * 1000;
		const minutes = parseInt(popupEl.getAttribute("data-cooldown-minutes"), 10);
		if (!Number.isFinite(minutes) || minutes < 0) return DEFAULT_COOLDOWN_MINUTES * 60 * 1000;
		return minutes * 60 * 1000;
	}

	function setSubmitButtonSubmitting(isSubmitting) {
		const btn = document.getElementById("gform_submit_button_" + getFormId());
		if (!btn) return;
		if (isSubmitting) {
			btn.setAttribute("data-original-value", btn.value || "Submit");
			btn.value = "Submitting...";
			btn.disabled = true;
		} else {
			btn.value = btn.getAttribute("data-original-value") || "Submit";
			btn.removeAttribute("data-original-value");
			btn.disabled = false;
		}
	}
	const STORAGE_KEY = "fd_lead_capture_submitted_at";
	const popup = document.getElementById("lead-capture-popup");
	const overlay = popup && popup.querySelector(".lead-capture-popup-overlay");
	const closeBtn = popup && popup.querySelector(".lead-capture-popup-close");
	const innerEl = popup && popup.querySelector(".lead-capture-popup-inner");

	let cachedFormHtml = null;

	function isWithinCooldown() {
		try {
			const submittedAt = localStorage.getItem(STORAGE_KEY);
			if (!submittedAt) return false;
			return Date.now() - parseInt(submittedAt, 10) < getCooldownMs();
		} catch {
			return false;
		}
	}

	function setCooldown() {
		try {
			localStorage.setItem(STORAGE_KEY, String(Date.now()));
		} catch (e) {}
	}

	function cacheFormHtml() {
		if (innerEl && !cachedFormHtml) {
			cachedFormHtml = innerEl.innerHTML;
		}
	}

	function resetGfSubmittingState() {
		try {
			window["gf_submitting_" + getFormId()] = false;
		} catch (e) {}
	}

	function isShowingConfirmation() {
		return (
			innerEl &&
			innerEl.querySelector("#gform_confirmation_wrapper_" + getFormId())
		);
	}

	function bindIframeLoadHandler() {
		if (typeof jQuery === "undefined") return;
		const formId = getFormId();
		const iframe = document.getElementById("gform_ajax_frame_" + formId);
		if (!iframe) return;
		jQuery(iframe)
			.off("load.leadCapture")
			.on("load.leadCapture", function () {
				const $iframe = jQuery(this);
				const $contents = $iframe.contents();
				const contents = $contents.find("*").html() || "";
				if (contents.indexOf("GF_AJAX_POSTBACK") < 0) return;
				const isConfirmation =
					$contents.find(
						"#gform_confirmation_wrapper_" + formId
					).length > 0;
				const isRedirect = contents.indexOf("gformRedirect(){") >= 0;
				if (isConfirmation && !isRedirect) {
					let confirmationContent = $contents
						.find(".GF_AJAX_POSTBACK")
						.html();
					if (!confirmationContent) confirmationContent = contents;
					jQuery("#gform_wrapper_" + formId).replaceWith(
						confirmationContent
					);
					jQuery(document).trigger("gform_confirmation_loaded", [
						formId,
					]);
					resetGfSubmittingState();
				} else {
					var formContent = $contents.find(
						"#gform_wrapper_" + formId
					);
					if (formContent.length) {
						jQuery("#gform_wrapper_" + formId).html(
							formContent.html()
						);
						var $wrapper = jQuery(
							"#gform_wrapper_" + formId
						);
						if (
							formContent.hasClass("gform_validation_error")
						) {
							$wrapper.addClass("gform_validation_error");
						} else {
							$wrapper.removeClass("gform_validation_error");
						}
						jQuery(document).trigger("gform_post_render", [
							formId,
							1,
							null,
						]);
						bindIframeLoadHandler();
					}
					setSubmitButtonSubmitting(false);
					resetGfSubmittingState();
				}
			});
	}

	function restoreForm() {
		if (innerEl && cachedFormHtml) {
			innerEl.innerHTML = cachedFormHtml;
			resetGfSubmittingState();
			if (typeof jQuery !== "undefined") {
				jQuery(document).trigger("gform_post_render", [
					getFormId(),
					1,
					null,
				]);
				bindIframeLoadHandler();
			}
		}
	}

	function openPopup(downloadUrl) {
		if (!popup) return;
		// Only restore form when popup is currently showing the confirmation (after a previous submit)
		if (isShowingConfirmation()) {
			restoreForm();
		} else {
			// Ensure iframe has load handler (handles first submit and cases where GF's handler isn't bound)
			bindIframeLoadHandler();
		}
		popup.setAttribute("data-pending-download", downloadUrl || "");
		popup.classList.add("is-open");
		popup.setAttribute("aria-hidden", "false");
		document.body.style.overflow = "hidden";
	}

	function closePopup() {
		if (!popup) return;
		popup.classList.remove("is-open");
		popup.setAttribute("aria-hidden", "true");
		popup.removeAttribute("data-pending-download");
		document.body.style.overflow = "";
	}

	function triggerDownload(url) {
		if (!url) return;
		const a = document.createElement("a");
		a.href = url;
		a.download = "";
		a.rel = "noopener";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	// Cache the initial form HTML on load so we can restore it after cooldown
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", cacheFormHtml);
	} else {
		cacheFormHtml();
	}

	// Lead capture form: show "Submitting..." as soon as submit button is clicked (so it’s visible while AJAX is pending)
	document.addEventListener(
		"click",
		function (e) {
			const btn = e.target.closest("#gform_submit_button_" + getFormId());
			if (btn && popup && popup.contains(btn)) {
				setTimeout(function () { setSubmitButtonSubmitting(true); }, 0);
				// Let the click continue so GF’s handler still runs (re-dispatch after a tick)
			}
		},
		true
	);

	document.addEventListener("click", function (e) {
		const trigger = e.target.closest(".lead-capture-form-trigger");
		if (trigger) {
			e.preventDefault();
			const url = trigger.getAttribute("data-download-url");
			if (url) {
				if (isWithinCooldown()) {
					triggerDownload(url);
				} else {
					openPopup(url);
				}
			}
		}
		if (e.target === overlay || e.target === closeBtn) {
			e.preventDefault();
			closePopup();
		}
	});

	document.addEventListener("keydown", function (e) {
		if (
			e.key === "Escape" &&
			popup &&
			popup.classList.contains("is-open")
		) {
			closePopup();
		}
	});

	// After lead capture form is submitted (Gravity Forms AJAX), trigger download, set cooldown, and close
	if (typeof jQuery !== "undefined") {
		jQuery(function () {
			jQuery(document).on(
				"gform_confirmation_loaded",
				function (e, formId) {
					if (parseInt(formId, 10) === getFormId()) {
						const url =
							popup &&
							popup.getAttribute("data-pending-download");
						if (url) {
							triggerDownload(url);
							setCooldown();
							resetGfSubmittingState();
							closePopup();
						}
					}
				}
			);
		});
	}
})();
